import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../data/content";
export function Testimonials() {
  return <section className="border-t border-line bg-panel px-5 py-20" data-id="element-107" data-mp="3kqw36hd9ewej">
      <div className="mx-auto max-w-5xl" data-id="element-108" data-mp="3fyvw84yrv38g">
        <h2 className="text-center font-display text-4xl uppercase text-cream sm:text-5xl" data-id="element-109" data-mp="3fxuittuaa4nk">
          Ils enseignent <span className="text-gold" data-id="element-110" data-mp="3ayhzvk6j9hq9">autrement</span>
        </h2>
        <div className="mt-12 grid gap-6 md:grid-cols-3" data-id="element-111" data-mp="36zqyh0v1bdxc">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-2xl border border-line bg-ink p-6" data-id="element-112" data-mp="31z3bcq9xfh8e">
              <div className="flex gap-1 text-gold" aria-label="5 étoiles sur 5" data-id="element-113" data-mp="2x1l0guccmrxr">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden data-id="element-114" data-mp="v9gavpibo6q7" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 font-serif text-lg italic leading-relaxed text-cream" data-id="element-115" data-mp="q9tzllm210k1">« {t.quote} »</blockquote>
              <figcaption className="mt-auto pt-6" data-id="element-116" data-mp="h4wsxwwqs2fk">
                <p className="font-bold text-cream" data-id="element-117" data-mp="m51dpz4onjbl">{t.name}</p>
                <p className="text-sm text-mute" data-id="element-118" data-mp="m6m6pkbcmu7c">{t.role}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}